module.exports = __webpack_public_path__ + "static/first_explain.bd961218.png";